export default "__VITE_ASSET__F55kzZTK__"